import { createContext, ReactNode } from "react";
import { useAuth } from "./useAuth";

const AuthContext = createContext({});
// add error handling later
export const AuthProvider = ({ children }: { children: ReactNode }) => {
    return <AuthContext.Provider value={ useAuth() }>{children}</AuthContext.Provider>;
};